import { createStructuredSelector } from "reselect"

import { OfficialSelect, OfficialsAndStaffSelect } from "app/static/frontend/selects/containers/PieSelect"
import { selectTeamMembersMentionTag } from "shared/userdata/userdata-selectors"

// Interaction Logger connection
export const getOfficialSelect = () => (Userdata.has_international_region ? OfficialsAndStaffSelect : OfficialSelect)

export const desktopLoggerFormConnection = createStructuredSelector({
    officialSelect: getOfficialSelect,
    teamMembersMentionTags: selectTeamMembersMentionTag,
})
